/** Drop executable tags from portal shell HTML used in static srcdoc previews. */
export function stripPortalScripts(html) {
  return String(html || '').replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '');
}
